var _style, _path, _rect, _text, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDFDFD;}\n\t.st1{fill:none;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{font-family:'DINNextLTPro-Condensed';}\n\t.st4{font-size:292.8728px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.3,610.6c0.6,1.3,2,3,1.6,3.8c-1.4,2.9-3.5,1.6-5.5,0.2C35.7,613.3,37,611.9,38.3,610.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -482.8,
    y: 531.7,
    className: "st1",
    width: 1867.7,
    height: 393.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.2686 730.8532)",
    className: "st2 st3 st4"
  }, "login info")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M627.9,252.6C616.4,165.5,533.5,97.9,433,97.9s-183.4,67.6-194.9,154.7c-69.8,0-126.4,50.6-126.4,113 s56.6,113,126.3,113h389.8c69.8,0,126.3-50.6,126.3-113S697.7,252.6,627.9,252.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8007c3a7d504a1f369b2bdae89038b1e.svg";
export { ForwardRef as ReactComponent };